<template>
  <nav class="m-nav" v-bind:class="{ 'close-nav': close }">
    <router-link to="/appointments/modal"><i class="fas fa-tty no-print"></i></router-link>

    <h1>
      <template v-if="$route.name === 'appointmentindex'">
        <i class="fa fa-car"></i>
      </template>
      <template v-else>
      </template>

      <template v-if="$route.name === 'familyindex'">
        <i class="fa fa-home"></i>
      </template>
      <template v-else>
      </template>

      <template v-if="$route.name === 'studentindex'">
        <template v-if="student.gender === 1">
          <i class="fa fa-user-circle man"></i>
        </template>
        <template v-if="student.gender === 2">
          <i class="fa fa-user-circle woman"></i>
        </template>
      </template>
      <template v-else>
      </template>

      <template v-if="$route.name === 'tutorindex'">
        <template v-if="tutor.gender === 0">
          <i class="fa fa-graduation-cap"></i>
        </template>
        <template v-if="tutor.gender === 1">
          <i class="fa fa-graduation-cap man"></i>
        </template>
        <template v-if="tutor.gender === 2">
          <i class="fa fa-graduation-cap woman"></i>
        </template>
      </template>
      <template v-else>
      </template>

      {{pageTitle}}
    </h1>

    <div class="m-nav__action">
      <ul>

        <li class="m-nav__action__layout no-print">
          <a @click="changeLayout('left')" v-bind:class="{ 'layout': this.$store.state.layout === 'left' }"></a>
          <a @click="changeLayout('split')" v-bind:class="{ 'layout': this.$store.state.layout === 'split' }"></a>
          <a @click="changeLayout('right')" v-bind:class="{ 'layout': this.$store.state.layout === 'right' }"></a>
        </li>

        <!-- <modal&#45;history></modal&#45;history> -->
        <li class="no-print">
          <!-- <a href="http://neo&#45;help.masterminds.jp/history" target="_blank"><i class="fa fa&#45;history" title="変更履歴" v&#45;bind:class="{'update': update}" @click="checkUpdate"></i>{{update}}</a> -->
          <a href="http://neo-help.masterminds.jp/history" target="_blank"><i class="fa fa-history" title="変更履歴" @click="checkUpdate"></i></a>
        </li>

        <li class="no-print">
          <router-link to="/appointments/calendar" target="_blank"><i class="fa fa-calendar-alt" title="APカレンダー"></i></router-link>
        </li>

        <!-- <template v&#45;if="$route.name === 'appointmentsadd'"> -->
        <!--   <li class="google"> -->
        <!--     <a href="https://docs.google.com/document/d/1DRPCauMahzK9OG5hUWuqYWx4xl8xauOlTbUsV2cxFs8/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
        <!--   </li> -->
        <!-- </template> -->

        <!-- <template v&#45;if="$route.name === 'familiesadd'"> -->
        <!--   <li class="google"> -->
        <!--     <a href="https://docs.google.com/document/d/1VXZ7PtEtOxF37NEf2OA7ynRne&#45;bjsSR6B_aKNnKfZe4/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
        <!--   </li> -->
        <!-- </template> -->

        <!-- <template v&#45;if="$route.name === 'studentsadd'"> -->
        <!--   <li class="google"> -->
        <!--     <a href="https://docs.google.com/document/d/13Pn4YLh_Bwz20wLhKPIXA6QzIBo9sXOE05NmmbHSRho/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
        <!--   </li> -->
        <!-- </template> -->

        <!-- <template v&#45;if="$route.name === 'tutorsadd'"> -->
        <!--   <li class="google"> -->
        <!--     <a href="https://docs.google.com/document/d/1Pl3sfbWSuUT0PqIunSpa&#45;Hy7EvhJ_smE6wYcC52KGIw/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
        <!--   </li> -->
        <!-- </template> -->

        <!-- <template v&#45;if="$route.name === 'agreementsadd'"> -->
        <!--   <li class="google"> -->
        <!--     <a href="https://docs.google.com/document/d/1UHXy0CLFQTYpcmfdqedcGkUQ8Pfp7F3gxeAMa1qP2n0/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
        <!--   </li> -->
        <!-- </template> -->

        <template v-if="$route.name === 'appointmentindex'">
          <li class="no-print">
            <a class="delete" @click="deleteAppointment(appointment)"><i class="fa fa-fw fa-trash-o"></i>AP削除</a>
          </li>
          <!-- <li class="google"> -->
          <!--   <a href="https://docs.google.com/document/d/1ajrufBqeelJn&#45;&#45;3hI3U3GSjVqxbxbAItdPst40_RrUo/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
          <!-- </li> -->
        </template>

        <template v-if="$route.name === 'familyindex'">
          <li class="no-print">
            <a class="delete" @click="deleteFamily(family)"><i class="fa fa-fw fa-trash-o"></i>家庭削除</a>
          </li>
          <!-- <li class="google"> -->
          <!--   <a href="https://docs.google.com/document/d/1f1x9stVumjTOyUBSM5AbaaIoe3c&#45;AsVxJdCFPUWbWrM/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
          <!-- </li> -->
        </template>

        <template v-if="$route.name === 'studentindex' ">
          <li class="no-print">
            <a class="delete" @click="deleteStudent(student)"><i class="fa fa-fw fa-trash-o"></i>生徒削除</a>
          </li>
          <!-- <li class="google"> -->
          <!--   <a href="https://docs.google.com/document/d/1Py0yzE5fid0XgKI41WLbBUJZLQhVhA8qDORZb2qlpAc/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
          <!-- </li> -->
        </template>

        <template v-if="$route.name === 'tutorindex'">
          <li class="no-print">
            <a class="delete" @click="deleteTutor(tutor)"><i class="fa fa-fw fa-trash-o"></i>先生削除</a>
          </li>
          <!-- <li class="google"> -->
          <!--   <a href="https://docs.google.com/document/d/1NiHJqlD1cThv8KXY8uBX&#45;1xUwCcC6xvzjaMNgt1Sbyw/edit?usp=sharing" target="_blank"><i class="fa fa&#45;lock"></i>Googleドキュメント</a> -->
          <!-- </li> -->
        </template>

        <template v-if="$route.name === 'agreementindex'">
          <li class="no-print">
            <a class="delete" @click="deleteAgreement(agreement)"><i class="fa fa-fw fa-trash-o"></i>契約削除</a>
          </li>
        </template>

        <li class="m-nav__action__logout no-print">
          <a @click="logout"><i class="fa fa-lock"></i>Log out</a>
        </li>

        <li class="type no-print" v-if="user">
          <a>{{user.type}}</a>
        </li>

        <li class="user-icon no-print">
          <a>{{officeName}}</a>
        </li>

        <li class="user-icon no-print">
          <a>{{userName}}</a>
          <!-- <div> -->
          <!--   <iframe -->
          <!--     style="width: 35px; height: 35px" -->
          <!--     v&#45;bind:src="user.img" -->
          <!--     frameborder="0"> -->
          <!--   </iframe> -->
          <!-- </div> -->
        </li>

      </ul>
    </div>
  </nav>
</template>

<script>
// import push from 'push.js'

export default {
  props: ['close'],
  data () {
    return {
      pageTitle: ''
    }
  },

  // created () {
  //   push.create('バージョン更新のお知らせ', {
  //     body: 'リロードしてください',
  //     // icon: 'icon.png',
  //     // timeout: 8000,
  //     // requireInteraction: true,
  //     onClick: function () {
  //       window.focus()
  //       this.close()
  //     }
  //   })
  // },
  computed: {
    login () {
      return this.$store.getters.login
    },

    update () {
      return this.$store.getters.update
    },

    user () {
      return this.$store.getters.user
    },

    userName () {
      if (this.user.user) {
        return this.user.user.charAt(0)
      } else {
        return ''
      }
    },

    offices () {
      return this.$store.getters.offices
    },

    officeName () {
      if (this.user.office_id) {
        const office = this.offices.filter(office => {
          return office.id === this.user.office_id
        })[0]
        if (office) {
          return office.name
        }
      } else {
        return 'ALL'
      }
    },

    appointment () {
      return this.$store.getters.appointment
    },

    family () {
      return this.$store.getters.family
    },

    student () {
      return this.$store.getters.student
    },

    tutor () {
      return this.$store.getters.tutor
    },

    agreement () {
      return this.$store.getters.agreement
    }
  },
  watch: {
    '$route.name': function (name) {
      if (name === 'index') {
        this.pageTitle = 'Top'
        document.title = 'Top'
      } else if (name === 'mypage') {
        this.pageTitle = 'My Page'
        document.title = 'My Page'
      } else if (name === 'familiesadd') {
        this.pageTitle = '家庭登録'
        document.title = '家庭登録'
      } else if (name === 'studentsadd') {
        this.pageTitle = '生徒登録'
        document.title = '生徒登録'
      } else if (name === 'appointmentsadd') {
        this.pageTitle = 'AP登録'
        document.title = 'AP登録'
      } else if (name === 'tutorsadd') {
        this.pageTitle = '先生登録'
        document.title = '先生登録'
      } else if (name === 'agreementsadd') {
        this.pageTitle = '契約情報登録'
        document.title = '契約情報登録'
      } else if (name === 'usersindex') {
        this.pageTitle = 'ユーザーリスト'
        document.title = 'ユーザーリスト'
      } else if (name === 'advisorsindex') {
        this.pageTitle = 'アドバイザー'
        document.title = 'アドバイザー'
      } else if (name === 'appointmentsindex') {
        this.pageTitle = 'APリスト'
        document.title = 'APリスト'
      } else if (name === 'confirmsindex') {
        this.pageTitle = '確認リスト'
        document.title = '確認リスト'
      } else if (name === 'familiesindex') {
        this.pageTitle = '家庭リスト'
        document.title = '家庭リスト'
      } else if (name === 'studentsindex') {
        this.pageTitle = '生徒リスト'
        document.title = '生徒リスト'
      } else if (name === 'tutorsindex') {
        this.pageTitle = '先生リスト'
        document.title = '先生リスト'
      } else if (name === 'agreementsindex') {
        this.pageTitle = '契約リスト'
        document.title = '契約リスト'
      } else if (name === 'student_tutorsindex') {
        this.pageTitle = '探しデータ'
        document.title = '探しデータ'
      } else if (name === 'tagsindex') {
        this.pageTitle = 'タグリスト'
        document.title = 'タグリスト'
      } else if (name === 'familyfilesindex') {
        this.pageTitle = '家庭ファイルリスト'
        document.title = '家庭ファイルリスト'
      } else if (name === 'studentfilesindex') {
        this.pageTitle = '生徒ファイルリスト'
        document.title = '生徒ファイルリスト'
      } else if (name === 'reportsindex') {
        this.pageTitle = '報告書'
        document.title = '報告書'
      } else if (name === 'tutorfilesindex') {
        this.pageTitle = '先生ファイルリスト'
        document.title = '先生ファイルリスト'
      } else if (name === 'eventsindex') {
        this.pageTitle = 'イベントリスト'
        document.title = 'イベントリスト'
      } else if (name === 'todosindex') {
        this.pageTitle = 'Todoリスト'
        document.title = 'Todoリスト'
      } else if (name === 'channelsindex') {
        this.pageTitle = '家庭教師登録媒体'
        document.title = '家庭教師登録媒体'
      } else if (name === 'tutor_channelsindex') {
        this.pageTitle = '家庭教師登録媒体リスト'
        document.title = '家庭教師登録媒体リスト'
      } else if (name === 'appointmentindex') {
        this.pageTitle = 'AP情報'
        document.title = 'AP情報'
      } else if (name === 'familyindex') {
        this.pageTitle = '家庭情報'
        document.title = '家庭情報'
      } else if (name === 'familyfileview') {
        this.pageTitle = '家庭ファイルリスト'
        document.title = '家庭ファイルリスト'
      } else if (name === 'appointmentsupportsindex') {
        this.pageTitle = 'AP対応履歴'
        document.title = 'AP対応履歴'
      } else if (name === 'familysupportsindex') {
        this.pageTitle = '家庭対応履歴'
        document.title = '家庭対応履歴'
      } else if (name === 'studentindex') {
        this.pageTitle = '生徒情報'
        document.title = '生徒情報'
      } else if (name === 'studentsindexinheritance') {
        this.pageTitle = '引継リスト'
        document.title = '引継リスト'
      } else if (name === 'studentfileview') {
        this.pageTitle = '生徒ファイルリスト'
        document.title = '生徒ファイルリスト'
      } else if (name === 'studentreports') {
        this.pageTitle = '指導報告書'
        document.title = '指導報告書'
      } else if (name === 'studentagreements') {
        this.pageTitle = '契約内容'
        document.title = '契約内容'
      } else if (name === 'tutorindex') {
        this.pageTitle = '先生情報'
        document.title = '先生情報'
      } else if (name === 'tutorfileview') {
        this.pageTitle = '先生ファイルリスト'
        document.title = '先生ファイルリスト'
      } else if (name === 'tutorsupportsindex') {
        this.pageTitle = '先生対応履歴'
        document.title = '先生対応履歴'
      } else if (name === 'tutorreports') {
        this.pageTitle = '指導報告書'
        document.title = '指導報告書'
      } else if (name === 'tutoragreements') {
        this.pageTitle = '契約内容'
        document.title = '契約内容'
      } else if (name === 'aggregatesappointments') {
        this.pageTitle = '集計-AP'
        document.title = '集計-AP'
      } else if (name === 'aggregatescontracts') {
        this.pageTitle = '集計-売上'
        document.title = '集計-売上'
      } else if (name === 'aggregatestutorchannels') {
        this.pageTitle = '集計-家庭教師'
        document.title = '集計-家庭教師'
      } else if (name === 'limitsindex') {
        this.pageTitle = '期限日リスト'
        document.title = '期限日リスト'
      } else if (name === 'completesindex') {
        this.pageTitle = '完了日リスト'
        document.title = '完了日リスト'
      } else if (name === 'conditionsindex') {
        this.pageTitle = '条件リスト'
        document.title = '条件リスト'
      } else if (name === 'student_conditionsindex') {
        this.pageTitle = '生徒条件リスト'
        document.title = '生徒条件リスト'
      } else if (name === 'tutor_conditionsindex') {
        this.pageTitle = '先生条件リスト'
        document.title = '先生条件リスト'
      } else {
        this.pageTitle = ''
        document.title = ''
      }
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
    },

    changeLayout (val) {
      this.$store.state.layout = val
    },

    checkUpdate () {
      this.$store.state.update = false
      // ローカルストレージにfalse入れて、でもそれだと初回ログイン毎回true、、、
    },

    deleteAppointment: function (appointment) {
      this.$store.dispatch('deleteAppointment', {
        this: this,
        appointment: appointment
      })
    },

    deleteFamily: function (family) {
      this.$store.dispatch('deleteFamily', {
        this: this,
        family: family
      })
    },
    deleteStudent: function (student) {
      this.$store.dispatch('deleteStudent', {
        this: this,
        student: student
      })
    },
    deleteTutor: function (tutor) {
      this.$store.dispatch('deleteTutor', {
        this: this,
        tutor: tutor
      })
    },
    deleteAgreement: function (agreement) {
      this.$store.dispatch('deleteAgreement', {
        this: this,
        agreement: agreement
      })
    }
  },
  mounted () {
    this.$store.dispatch('getUser')
    this.$store.dispatch('getOffices')
  }
}
</script>

<style lang="scss" scoped>
.m-nav {
  position: fixed;
  top:0;
  left: 220px;
  width: calc(100% - 220px);
  height: 45px;
  background: #f4f4f4;
  padding: 0 .5em;
  /* box-shadow: 0px 1px 1px #ccc; */
  border-bottom: solid 1px #eaecef;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: all 600ms cubic-bezier(0.86, 0, 0.07, 1);
  h1 {
    font-size: 15px;
    color: #37474f;
    margin: 0;
    margin-left: auto;
    line-height: 1;
    font-weight: bold;
  }
}
.close-nav {
  left: 52px;
  width: calc(100% - 52px);
}
.m-nav__action {
  margin-left: auto;
  flex-basis: 30%;
  ul {
    list-style-type: none;
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
    font-size: .85em;
    margin: 0;
    li {
      white-space: nowrap;
      margin-left: 1em;
      align-self: center;
      a {
        cursor: pointer;
        transition: opacity .5s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
      .delete {
        color: #37474f;
      }
    }
  }
}
.m-nav__action__logout {
  background: #37474F;
  border-radius: 50px;
  position: relative;
  a {
    display: block;
    text-decoration: none;
    padding: 11px;
    color: #fff;
    .fa-lock {
      margin-right: 5px;
    }
  }
}
.m-nav__action__layout {
  background: #fff;
  border-radius: 50px;
  position: relative;
  border: 2px solid #37474F;
  display: flex;
  background: #37474F;
  a {
    display: block;
    border-radius: 50px;
    text-decoration: none;
    padding: 11px;
    color: #37474F;
  }
}
.layout {
  background: #fff;
}
.google {
  background: #4285f4;
  border-radius: 50px;
  position: relative;
  a {
    display: block;
    text-decoration: none;
    padding: 11px;
    color: #fff;
    .fa-lock {
      margin-right: 5px;
    }
  }
}
.type {
  background: #039be5;
  border-radius: 50px;
  position: relative;
  a {
    display: block;
    text-decoration: none;
    padding: 11px;
    color: #fff;
    .fa-lock {
      margin-right: 5px;
    }
  }
}
.user-icon {
  background: #41B883;
  border-radius: 50px;
  position: relative;
  a {
    display: block;
    text-decoration: none;
    padding: 11px;
    color: #fff;
    .fa-lock {
      margin-right: 5px;
    }
  }
}
.fa-car, .fa-home, .fa-user-circle, .fa-graduation-cap {
  font-size: 20px;
  margin: 0 10px;
}
.fa-history, .fa-calendar-alt {
  font-size: 25px;
}
.man {
  color: #3F51B5;
}
.woman {
  color: #E91E63;
}
.update {
  color: red
}

@media print {
  .no-print {
    display: none;
  }
}

.fa-tty {
  color: #37474f;
  font-size: 20px;
  padding: 5px;
  width: 35px;
  height: 35px;
  cursor: pointer;
  z-index: 1;
  padding: 8px 0 0 8px;
}
</style>



// WEBPACK FOOTER //
// TopNavi.vue?54b84e74